import React, {useEffect, useState} from "react";
import {
  Container,
  Row,
  Col,
  FormGroup,
  FormLabel,
  Alert, Modal,
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import * as fb from '../../firebase';
import {
  addAdminLog,
} from "components/Helper/index";
import { Link } from "react-router-dom";
import StringArrayInput from "../../components/StringArrayInput/StringArrayInput";
import AddClassPopup from "./AddClassPoup";

const AddProductGroup = (props) => {
  const [product, setProduct] = useState({})
  const [ref, setRef] = useState("")
  const [classes, setClasses] = useState([])
  const [products, setProducts] = useState([])
  const [error, setError] = useState("")
  const [errors, setErrors] = useState({})
  const [disabled, setDisabled] = useState(false)
  const [showClassPopup, setShowClassPopup] = useState(false)
  const [prices, setPrices] = useState({uk:0, hu:0})

  useEffect(() => {
    fetchClasses()
    getProducts()
  }, []);

  const fetchClasses = async () => {
    try {
      const settings = await fb.metaCollection.doc('settings').get().then(doc => {
        return doc.exists ? doc.data() : null
      });

      if(settings && settings.hasOwnProperty('shopify_groups')){
        setClasses(settings.shopify_groups)
      }else{
        setClasses([])
      }
    }catch(err){
      setError(err.message)
    }
  }

  const getProducts = () => {
    fb.productsCollection.get().then((query) => {
      if(!query.empty){
        let  prs = []
        query.docs.forEach(doc => {
          prs.push({
            title: doc.data().title,
            ref: doc.data().ref
          })
        })
        setProducts(prs.sort((a, b) => {
          const numA = parseInt(a.ref.match(/\d+/)?.[0] || '0', 10);
          const numB = parseInt(b.ref.match(/\d+/)?.[0] || '0', 10);
          return numA - numB;
        }))
      }
    })
  }

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;

    if(!ref){
      formIsValid = false;
      errors["ref"] = "Class is required";
    }

    if(!product.name){
      formIsValid = false;
      errors["name"] = "Title is required";
    }

    if(ref !== 'rb' && !product.order){
      formIsValid = false;
      errors["order"] = "Order is required";
    }

    if((ref === 'rb' && !product.id) || (ref !== 'rb' && (!product.id || product.id.length === 0))){
      formIsValid = false;
      errors["id"] = "Id is required";
    }

    if(ref !== 'rb' && (!product.products || product.products.length === 0)){
      formIsValid = false;
      errors["products"] = "Products is required";
    }

    if(!prices.uk){
      formIsValid = false;
      errors["uk"] = "Price UK is required";
    }

    if(!prices.hu){
      formIsValid = false;
      errors["hu"] = "Price HU is required";
    }

    setErrors(errors)
    return formIsValid;
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setDisabled(true)
    if(handleValidation()){
      let docRef = fb.metaCollection.doc(`shopify_${ref === 'rb' ? '' : `${ref}_`}products`)
      await docRef.get().then(async (doc) => {
        if (doc.exists && doc.data().hasOwnProperty('ids')) {
          let ids = doc.data().ids
          ids.push(product)
          await docRef.update({ids}).then(() => {
            addAdminLog(
              'product_group_created',
              `Created the product ${ref} ${ids.length - 1}`,
              `${ref}-${ids.length - 1}`
            )
            props.history.push('/admin/product_groups');
          }).catch(err=> {
            setError(`Something went wrong-${err}`)
            setDisabled(false)
          });
        }
      })
      let pp = {}
      pp[`${ref}${product.name.replace(/ /g, '')}PricePartner0UK`] = prices.uk
      pp[`${ref}${product.name.replace(/ /g, '')}PricePartner0HU`] = prices.hu
      await fb.metaCollection.doc(`PartnersPrices`).update(pp)
    }else{
      setDisabled(false)
    }
  }

  const orderOptions = () => {
    let out = []
    for (let i = 0; i < 100; i++) {
      out.push(<option key={i} value={i+1}>{i+1}</option>)
    }
    return out
  }

  const changeProduct = (e,field) => {
    let value = e.target.value
    setProduct(prev => ({...prev, [field]: value}))
  }

  const changePrice = (e,field) => {
    let value = parseInt(e.target.value*100)
    setPrices(prev => ({...prev, [field]: value}))
  }

  const changeProducts = (e,i) => {
    let prs = [...product.products]
    prs[i] = {...prs[i], ref: e.currentTarget.value}
    setProduct(prev => ({...prev, products: prs}))
  }

  const changeAllergy = (e,i) => {
    let prs = [...product.products]
    let updatedProduct = { ...prs[i] }
    if (e.currentTarget.value === "") {
      delete updatedProduct.allergy
    } else {
      updatedProduct.allergy = e.currentTarget.value === "true"
    }
    prs[i] = updatedProduct
    setProduct(prev => ({ ...prev, products: prs }))
  }

  const deleteProduct = (i) => {
    let prs = [...product.products]
    prs.splice(i, 1);
    setProduct(prev => ({ ...prev, products: prs }))
  }

  const addProduct = () => {
    let prs = []
    if(product.products){
      prs = [...product.products]
    }
    prs.push({ref: ''})
    setProduct(prev => ({ ...prev, products: prs }))
  }

  const addClass = async (newClass,newPrices) => {
    let cs = [...classes]
    if (!cs.some(item => item.ref === newClass.ref)) {
      cs.push(newClass);
      await fb.metaCollection.doc('settings').update({shopify_groups: cs})
      await fb.metaCollection.doc(`shopify_${newClass.ref}_products`).set({ids:[]})

      let prices = {}
      prices[`${newClass.ref}PricePartner0UK`] = newPrices.uk
      prices[`${newClass.ref}PricePartner0HU`] = newPrices.hu
      await fb.metaCollection.doc(`PartnersPrices`).update(prices)

      await fetchClasses()
      setRef(newClass.ref)
      setShowClassPopup(false)
    }
  }

  return (<div className="content">
    <Container fluid>
      <Row>
        <Col md={12}>
          {error &&
            <Alert bsStyle="danger">
              <span>{error}</span>
            </Alert>
          }
          <Card
            title="Add Product Group"
            button={
              <Link to={`/admin/product_groups`} className="btn btn-success pull-left card-back-button libi-admin-btn"> Back</Link>
            }
            content={
              <form onSubmit={handleSubmit}>
                <Row>
                  <Col md={5}>
                    <FormGroup>
                      <FormLabel>Class</FormLabel>
                      <select
                        className= "form-control"
                        name= "class"
                        value={ref || ''}
                        onChange={(e) =>  {let value = e.target.value; setRef(value)}}
                      >
                        <option value="">Select Class</option>
                        {classes.sort((a,b) => a.order - b.order).map((c,k) => <option key={k} value={c.ref}>{c.title}</option>)}
                      </select>
                      <span className="help-block">{errors.ref}</span>
                    </FormGroup>
                  </Col>
                  <Col md={1}>
                    <FormGroup>
                      <FormLabel></FormLabel>
                      <a href="#" onClick={() => setShowClassPopup(true)}><i className="fa fa-plus" /></a>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <FormLabel>Shopify ids</FormLabel>
                      {ref === 'rb' ?
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter an id"
                          name="id"
                          value= {product?.id || ''}
                          onChange={(e) =>  changeProduct(e,'id')}
                        />
                        :
                        <StringArrayInput
                          placeholder="Enter an id"
                          onChange={(value) =>  setProduct(prev => ({...prev, id: value}))}
                          value={product?.id || []}
                        />
                      }
                      <span className="help-block">{errors.id}</span>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <div className="col-md-6">
                    <FormGroup>
                      <FormLabel>Title</FormLabel>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Title"
                        name="name"
                        value= {product?.name || ''}
                        onChange={(e) =>  changeProduct(e,'name')}
                      />
                      <span className="help-block">{errors.name}</span>
                    </FormGroup>
                  </div>
                  {ref !== 'rb' ? <div className="col-md-6">
                    <FormGroup>
                      <FormLabel>Order</FormLabel>
                      <select
                        className= "form-control"
                        name= "order"
                        value={product?.order || ''}
                        onChange={(e) =>  changeProduct(e,'order')}
                      >
                        <option value="">Select Order</option>
                        {orderOptions()}
                      </select>
                      <span className="help-block">{errors.order}</span>
                    </FormGroup>
                  </div> : null}
                  {ref !== 'rb' ? <div className="col-md-6">
                    <FormGroup>
                      <FormLabel>Price UK</FormLabel>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="0.00"
                        value= {prices?.uk/100 || ''}
                        onChange={(e) =>  changePrice(e,'uk')}
                      />
                      <span className="help-block">{errors.uk}</span>
                    </FormGroup>
                  </div> : null}
                  {ref !== 'rb' ? <div className="col-md-6">
                    <FormGroup>
                      <FormLabel>Price HU</FormLabel>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="0.00"
                        value= {prices?.hu/100 || ''}
                        onChange={(e) =>  changePrice(e,'hu')}
                      />
                      <span className="help-block">{errors.hu}</span>
                    </FormGroup>
                  </div> : null}
                </Row>
                {ref !== 'rb' ? <Row>
                  <Col md={12}>
                    {product.products && product.products.map((p,i) => {
                      return <Row key={i}>
                        <Col md={6}>
                          <FormGroup>
                            <FormLabel>Product</FormLabel>
                            <select
                              className= "form-control"
                              name="product"
                              value={p.ref || ''}
                              onChange={(e) =>  changeProducts(e,i)}
                            >
                              <option value="">Select Product</option>
                              {products.map((pr,j) => <option key={j} value={pr.ref}>{pr.title}</option>)}
                            </select>
                          </FormGroup>
                        </Col>
                        <Col md={5}>
                          <FormGroup>
                            <FormLabel>Allergy</FormLabel>
                            <select
                              className="form-control"
                              name="allergy"
                              value={p.allergy || ''}
                              onChange={(e) =>  changeAllergy(e,i)}
                            >
                              <option value="">Not selected</option>
                              <option value="true">Allergy</option>
                              <option value="false">Non-Allergy</option>
                            </select>
                          </FormGroup>
                        </Col>
                        <Col md={1}>
                          <FormGroup>
                            <FormLabel></FormLabel>
                            <a href="#" onClick={() => {deleteProduct(i)}}><i className="fa fa-times" /></a>
                          </FormGroup>
                        </Col>
                      </Row>
                    })}
                  </Col>
                  <Col md={12}>
                    <Button
                      className="btn-fill libi-admin-btn mb-2"
                      bsStyle="success"
                      type="button"
                      onClick={() => addProduct()}
                    >
                      Add product
                    </Button>
                  </Col>
                  <span className="help-block">{errors.products}</span>
                </Row> : null}

                <Row></Row>
                <Button
                  className="btn-fill pull-right libi-admin-btn"
                  bsStyle="info"
                  type="submit"
                  disabled={disabled}
                >
                  {disabled ? 'Uploading..' : 'Create'}
                </Button>
                <div className="clearfix" />
              </form>
            }
          />
        </Col>
      </Row>
    </Container>
    <AddClassPopup
      onCreate={addClass}
      show={showClassPopup}
      onHide={() => setShowClassPopup(false)}
    />
  </div>)
}

export default AddProductGroup;
